<template>
  <data-list
      ref="dataList"
      class="content md"
      url="/h5/sc-sign"
      entity-name="问题"
      add-btn=""
      hide-action
      :custom-url="customUrl"
      :action="action"
      :columns="columns"
      query="&sort=-id"
  >
    <template #query="{ form }">
      <a-form-model-item label="互动状态">
        <a-select
            placeholder="选择互动状态筛选"
            @change="getList"
            :options="statusList"
            v-model="form.status"
            style="width: 200px">
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="">
        <a-input v-model="form.keyword" placeholder="输入姓名或手机号查询" @keyup.enter="getList" style="width: 200px"></a-input>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
export default {
  name: "Scene",
  data() {
    return {
      columns: [
        {title: '时间', dataIndex: 'create_time'},
        {title: '姓名', dataIndex: 'name'},
        {title: '联系方式', dataIndex: 'mobile'},
        {title: '互动问题', dataIndex: 'quiz'},
      ],
      statusList: [
        {key: 0, title: '全部'},
        {key: 1, title: '已提问'},
        // {key: 2, title: '未提问'},
      ]
    }
  },
  computed: {
    action() {
      return this.$route.meta.action;
    },
  },
  methods: {
    getList() {
      this.$refs.dataList.getList();
    },
    customUrl(form) {
      let res = '';
      if (form.status === 1) {
        res += `&filter[quiz][neq]=null`
      }
      if (form.keyword) {
        res += `&filter[or][0][name][like]=${form.keyword}&filter[or][1][mobile][like]=${form.keyword}`
      }
      return res;
    }
  }
}
</script>

<style scoped>

</style>
